import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { FaCalculator } from "react-icons/fa";
import Message from "./Message";

const FallRiskAssessmentAdult = ({ setHendrich, hendrich }) => {
  // Hendrich II Risk Factors
  const [selectedPostOp, setSelectedPostOp] = useState(
    hendrich?.selectedPostOp || "",
  );
  const [selectedGait, setSelectedGait] = useState(
    hendrich?.selectedGait || "",
  );
  const [selectedStroke, setSelectedStroke] = useState(
    hendrich?.selectedStroke || "",
  );
  const [selectedConfusionTIA, setSelectedConfusionTIA] = useState(
    hendrich?.selectedConfusionTIA || "",
  );
  const [selectedWeakness, setSelectedWeakness] = useState(
    hendrich?.selectedWeakness || "",
  );
  const [selectedDizziness, setSelectedDizziness] = useState(
    hendrich?.selectedDizziness || "",
  );
  const [selectedPsych, setSelectedPsych] = useState(
    hendrich?.selectedPsych || "",
  );
  const [selectedConfused, setSelectedConfused] = useState(
    hendrich?.selectedConfused || "",
  );
  const [selectedLimitations, setSelectedLimitations] = useState(
    hendrich?.selectedLimitations || "",
  );
  const [selectedElimination, setSelectedElimination] = useState(
    hendrich?.selectedElimination || "",
  );
  const [selectedMedication, setSelectedMedication] = useState(
    hendrich?.selectedMedication || "",
  );
  const [selectedHearingVisual, setSelectedHearingVisual] = useState(
    hendrich?.selectedHearingVisual || "",
  );
  const [selectedPreviousFalls, setSelectedPreviousFalls] = useState(
    hendrich?.selectedPreviousFalls || "",
  );
  const [selectedAssistiveDevice, setSelectedAssistiveDevice] = useState(
    hendrich?.selectedAssistiveDevice || "",
  );
  const [selectedAge70, setSelectedAge70] = useState(
    hendrich?.selectedAge70 || "",
  );
  const [selectedOsteoporosis, setSelectedOsteoporosis] = useState(
    hendrich?.selectedOsteoporosis || "",
  );
  const [showResult, setShowResult] = useState(false);
  const [riskHandled, setRiskHandled] = useState(
    hendrich?.riskHandled || false,
  );
  const [error, setError] = useState("");

  const postOpOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Within 24 hours post anesthesia / sedation", value: "4" },
    { label: "No", value: "0" },
  ];
  const gaitOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Gait disturbance – shuffling, jerking, or swaying", value: "3" },
    { label: "No gait disturbance", value: "0" },
  ];
  const strokeOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "History of stroke", value: "3" },
    { label: "No history of stroke", value: "0" },
  ];
  const confusionTIAOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Intermittent confusion or TIA", value: "3" },
    { label: "No intermittent confusion / TIA", value: "0" },
  ];
  const weaknessOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Generalized weakness", value: "3" },
    { label: "No generalized weakness", value: "0" },
  ];
  const dizzinessOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Dizziness / Syncope", value: "3" },
    { label: "No dizziness / syncope", value: "0" },
  ];
  const psychOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Psychological / behavioral disorders", value: "2" },
    { label: "No psychological / behavioral disorder", value: "0" },
  ];
  const confusedOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Confused all the time", value: "3" },
    { label: "Not confused all the time", value: "0" },
  ];
  const limitationsOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Not aware of limitations", value: "3" },
    { label: "Aware of limitations", value: "0" },
  ];
  const eliminationOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Nocturia / Incontinence", value: "3" },
    { label: "No nocturia / incontinence", value: "0" },
  ];
  const medicationOptions = [
    { label: "Select", value: "", disabled: true },
    {
      label: "Diuretics, narcotics, sedatives, antipsychotics, or chemotherapy",
      value: "2",
    },
    { label: "None of the above", value: "0" },
  ];
  const hearingVisualOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Hearing / visual impairment", value: "2" },
    { label: "No hearing / visual impairment", value: "0" },
  ];
  const previousFallsOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Previous falls within last 12 months", value: "2" },
    { label: "No previous falls", value: "0" },
  ];
  const assistiveDeviceOptions = [
    { label: "Select", value: "", disabled: true },
    {
      label: "Patient uses assistive device / furniture / equipment",
      value: "3",
    },
    { label: "No assistive device", value: "0" },
  ];
  const age70Options = [
    { label: "Select", value: "", disabled: true },
    { label: "70 years or greater", value: "1" },
    { label: "Less than 70 years", value: "0" },
  ];
  const osteoporosisOptions = [
    { label: "Select", value: "", disabled: true },
    { label: "Osteoporosis", value: "1" },
    { label: "No osteoporosis", value: "0" },
  ];

  const LOW_RISK_INTERVENTIONS = [
    "Orient patient and family to the surroundings and call-light use",
    "Keep the bed in the lowest position with wheels locked",
    "Keep frequently used items within easy reach",
    "Provide non-slip footwear",
    "Supervise or assist during transfers and toileting",
    "Reassess the score whenever the patient's condition changes",
  ];

  const HIGH_RISK_INTERVENTIONS = [
    ...LOW_RISK_INTERVENTIONS,
    'Apply a "Fall Risk" wrist band and place a fall-risk sign at the bedside',
    "Activate a bed or chair alarm",
    "Increase rounding to at least once every hour",
    "Consider one-on-one supervision for patients who cannot follow instructions",
    "Request a physical therapy consult for gait and mobility training",
    "Hand off fall-risk status at every shift change",
  ];

  const [calculatedScore, setCalculatedScore] = useState(0);

  // Hendrich II: Score >= 5 = High Risk
  const isHighRisk = calculatedScore >= 5;
  const interventions = isHighRisk
    ? HIGH_RISK_INTERVENTIONS
    : LOW_RISK_INTERVENTIONS;

  const handleCalculation = () => {
    if (
      selectedPostOp === "" ||
      selectedGait === "" ||
      selectedStroke === "" ||
      selectedConfusionTIA === "" ||
      selectedWeakness === "" ||
      selectedDizziness === "" ||
      selectedPsych === "" ||
      selectedConfused === "" ||
      selectedLimitations === "" ||
      selectedElimination === "" ||
      selectedMedication === "" ||
      selectedHearingVisual === "" ||
      selectedPreviousFalls === "" ||
      selectedAssistiveDevice === "" ||
      selectedAge70 === "" ||
      selectedOsteoporosis === ""
    ) {
      setError("Kindly, compelete all items then press calculate");

      return;
    }
    setRiskHandled(!riskHandled);
  };
  useEffect(() => {
    setHendrich({
      selectedPostOp,
      selectedGait,
      selectedStroke,
      selectedConfusionTIA,
      selectedWeakness,
      selectedDizziness,
      selectedPsych,
      selectedConfused,
      selectedLimitations,
      selectedElimination,
      selectedMedication,
      selectedHearingVisual,
      selectedPreviousFalls,
      selectedAssistiveDevice,
      selectedAge70,
      selectedOsteoporosis,
      riskHandled,
    });
    setCalculatedScore(
      Number(selectedPostOp) +
        Number(selectedGait) +
        Number(selectedStroke) +
        Number(selectedConfusionTIA) +
        Number(selectedWeakness) +
        Number(selectedDizziness) +
        Number(selectedPsych) +
        Number(selectedConfused) +
        Number(selectedLimitations) +
        Number(selectedElimination) +
        Number(selectedMedication) +
        Number(selectedHearingVisual) +
        Number(selectedPreviousFalls) +
        Number(selectedAssistiveDevice) +
        Number(selectedAge70) +
        Number(selectedOsteoporosis),
    );
  }, [
    selectedPostOp,
    selectedGait,
    selectedStroke,
    selectedConfusionTIA,
    selectedWeakness,
    selectedDizziness,
    selectedPsych,
    selectedConfused,
    selectedLimitations,
    selectedElimination,
    selectedMedication,
    selectedHearingVisual,
    selectedPreviousFalls,
    selectedAssistiveDevice,
    selectedAge70,
    selectedOsteoporosis,
    riskHandled,
  ]);
  return (
    <>
      <Form>
        <Form.Group controlId="postOpScore">
          <Form.Label>Within 24 Hours Post Anesthesia / Sedation</Form.Label>
          <Form.Control
            as="select"
            value={selectedPostOp}
            onChange={(e) => setSelectedPostOp(e.target.value)}
            className="custom-select"
            isValid={selectedPostOp}
            isInvalid={selectedPostOp === ""}
          >
            {postOpOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="gaitScore">
          <Form.Label>Gait Disturbance</Form.Label>
          <Form.Control
            as="select"
            value={selectedGait}
            onChange={(e) => setSelectedGait(e.target.value)}
            className="custom-select"
            isValid={selectedGait}
            isInvalid={selectedGait === ""}
          >
            {gaitOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="strokeScore">
          <Form.Label>History of Stroke</Form.Label>
          <Form.Control
            as="select"
            value={selectedStroke}
            onChange={(e) => setSelectedStroke(e.target.value)}
            className="custom-select"
            isValid={selectedStroke}
            isInvalid={selectedStroke === ""}
          >
            {strokeOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="confusionTIAScore">
          <Form.Label>Intermittent Confusion / TIA</Form.Label>
          <Form.Control
            as="select"
            value={selectedConfusionTIA}
            onChange={(e) => setSelectedConfusionTIA(e.target.value)}
            className="custom-select"
            isValid={selectedConfusionTIA}
            isInvalid={selectedConfusionTIA === ""}
          >
            {confusionTIAOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="weaknessScore">
          <Form.Label>Generalized Weakness</Form.Label>
          <Form.Control
            as="select"
            value={selectedWeakness}
            onChange={(e) => setSelectedWeakness(e.target.value)}
            className="custom-select"
            isValid={selectedWeakness}
            isInvalid={selectedWeakness === ""}
          >
            {weaknessOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="dizzinessScore">
          <Form.Label>Dizziness / Syncope</Form.Label>
          <Form.Control
            as="select"
            value={selectedDizziness}
            onChange={(e) => setSelectedDizziness(e.target.value)}
            className="custom-select"
            isValid={selectedDizziness}
            isInvalid={selectedDizziness === ""}
          >
            {dizzinessOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="psychScore">
          <Form.Label>Psychological / Behavioral Disorders</Form.Label>
          <Form.Control
            as="select"
            value={selectedPsych}
            onChange={(e) => setSelectedPsych(e.target.value)}
            className="custom-select"
            isValid={selectedPsych}
            isInvalid={selectedPsych === ""}
          >
            {psychOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="confusedScore">
          <Form.Label>Confused All the Time</Form.Label>
          <Form.Control
            as="select"
            value={selectedConfused}
            onChange={(e) => setSelectedConfused(e.target.value)}
            className="custom-select"
            isValid={selectedConfused}
            isInvalid={selectedConfused === ""}
          >
            {confusedOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="limitationsScore">
          <Form.Label>Not Aware of Limitations</Form.Label>
          <Form.Control
            as="select"
            value={selectedLimitations}
            onChange={(e) => setSelectedLimitations(e.target.value)}
            className="custom-select"
            isValid={selectedLimitations}
            isInvalid={selectedLimitations === ""}
          >
            {limitationsOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="eliminationScore">
          <Form.Label>Nocturia / Incontinence</Form.Label>
          <Form.Control
            as="select"
            value={selectedElimination}
            onChange={(e) => setSelectedElimination(e.target.value)}
            className="custom-select"
            isValid={selectedElimination}
            isInvalid={selectedElimination === ""}
          >
            {eliminationOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="medicationScore">
          <Form.Label>Medications</Form.Label>
          <Form.Control
            as="select"
            value={selectedMedication}
            onChange={(e) => setSelectedMedication(e.target.value)}
            className="custom-select"
            isValid={selectedMedication}
            isInvalid={selectedMedication === ""}
          >
            {medicationOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="hearingVisualScore">
          <Form.Label>Hearing / Visual Impairment</Form.Label>
          <Form.Control
            as="select"
            value={selectedHearingVisual}
            onChange={(e) => setSelectedHearingVisual(e.target.value)}
            className="custom-select"
            isValid={selectedHearingVisual}
            isInvalid={selectedHearingVisual === ""}
          >
            {hearingVisualOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="previousFallsScore">
          <Form.Label>Previous Falls Within Last 12 Months</Form.Label>
          <Form.Control
            as="select"
            value={selectedPreviousFalls}
            onChange={(e) => setSelectedPreviousFalls(e.target.value)}
            className="custom-select"
            isValid={selectedPreviousFalls}
            isInvalid={selectedPreviousFalls === ""}
          >
            {previousFallsOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="assistiveDeviceScore">
          <Form.Label>Uses Assistive Device / Furniture / Equipment</Form.Label>
          <Form.Control
            as="select"
            value={selectedAssistiveDevice}
            onChange={(e) => setSelectedAssistiveDevice(e.target.value)}
            className="custom-select"
            isValid={selectedAssistiveDevice}
            isInvalid={selectedAssistiveDevice === ""}
          >
            {assistiveDeviceOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="age70Score">
          <Form.Label>Age 70 Years or Greater</Form.Label>
          <Form.Control
            as="select"
            value={selectedAge70}
            onChange={(e) => setSelectedAge70(e.target.value)}
            className="custom-select"
            isValid={selectedAge70}
            isInvalid={selectedAge70 === ""}
          >
            {age70Options.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="osteoporosisScore">
          <Form.Label>Osteoporosis</Form.Label>
          <Form.Control
            as="select"
            value={selectedOsteoporosis}
            onChange={(e) => setSelectedOsteoporosis(e.target.value)}
            className="custom-select"
            isValid={selectedOsteoporosis}
            isInvalid={selectedOsteoporosis === ""}
          >
            {osteoporosisOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      </Form>
      {error && (
        <Message
          children={"Kindly, compelete all items firstly"}
          variant={`danger`}
          setMessage={setError}
        />
      )}
      <div className="text-center ">
        <h3>
          <Form.Check
            type="checkbox"
            id="fall"
            checked={riskHandled}
            label={
              <span
                onClick={() => handleCalculation()}
                className={riskHandled ? "text-success" : "text-danger"}
              >
                {`Fall Risk Score is ${calculatedScore} and all recommended measures are ${
                  !riskHandled ? "NOT " : ""
                }done`}
              </span>
            }
          />
        </h3>
      </div>

      {!riskHandled && (
        <Alert variant={isHighRisk ? "danger" : "success"} className="m-4 row">
          <Col className="col-sm-10">
            <>
              <h5>Risk Level: {isHighRisk ? "High" : "Low"}</h5>
              <h5>Recommended Interventions:</h5>
              <ul>
                {interventions.map((intervention, index) => (
                  <li key={index}>{intervention}</li>
                ))}
              </ul>{" "}
            </>
          </Col>
        </Alert>
      )}
    </>
  );
};

export default FallRiskAssessmentAdult;
